module.exports = __webpack_public_path__ + "img/img37.11ebadb3.svg";